import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import * as calendarHelpers from '@common/brzw_calendar/helpers';
import TaskDropdownList from '@common/components/task_dropdown_list/task_dropdown_list';
import { SingleTask } from '@common/brzw_calendar/commons';
import MultipleSkeleton from '../../skeletons/multiple_skeleton';

import './tasks_cell.scss';

const CLASS_NAME = 'tasks-cell';

const countExtraTasks = (tasks, limit = 3) => {
  const tasksSize = _.size(tasks);
  const limitedTasks = tasksSize > limit + 1 ? [..._.slice(tasks, 0, limit)] : tasks;
  const toolTipTasks = tasksSize > limit + 1 ? [..._.slice(tasks, limit)] : [];
  const tooltipTasksSize = _.size(toolTipTasks);
  return { limitedTasks, tooltipTasksSize, toolTipTasks };
};

const badgeNumber = task => {
  const commentCount = _.get(task, 'comment_count');
  return commentCount > 0 ? commentCount : undefined;
};

const TasksCell = (props, customProps) => {
  const type = _.get(customProps, 'type');
  const limit = _.get(customProps, 'limit');
  const tasks = _.get(props, type);
  const tableContainerHeight = _.get(customProps, 'tableContainerHeight');
  const headerTitle = _.get(customProps, 'headerTitle');
  const readyStatus = _.get(props, 'ready_status.type_property_ready_status');
  const defaultCell = _.get(customProps, 'defaultCell');
  const isTaskInactiveByFilter = _.get(customProps, 'isTaskIncorrect');
  const withSkeletons = _.get(customProps, 'withSkeletons');
  const withLimit = _.get(customProps, 'withLimit');

  if (withSkeletons && _.isUndefined(tasks)) {
    return <MultipleSkeleton />;
  }

  if (_.isEmpty(_.keys(tasks))) {
    return <div className="default-cell--empty"> - </div>;
  }

  const { limitedTasks, toolTipTasks, tooltipTasksSize } = countExtraTasks(tasks, limit);
  const allTasks = withLimit ? limitedTasks : tasks;
  const allTasksSize = _.size(allTasks);
  const tooltipSettings = {
    containerHeight: window.innerHeight,
    containerWidth: window.outerWidth,
  };

  const renderTasks = _.map(allTasks, (task, index) => {
    let singleTaskProps = calendarHelpers.getSingleTaskProps(task);
    singleTaskProps = _.omit(singleTaskProps, 'onTaskClick');
    const lastOrFirst = index === 0 || index === allTasksSize - 1;
    const isInactive =
      _.isFunction(isTaskInactiveByFilter) &&
      isTaskInactiveByFilter(singleTaskProps);

    return (
      <SingleTask
        containerClassName={classnames({ 'brzw-calendar-single-task--inactive': isInactive })}
        badgeNumber={badgeNumber(task)}
        key={`task-cell-${index}-${task.id}`}
        readyStatus={readyStatus}
        tooltipSettings={{
          ...tooltipSettings,
          paddingHorizontalRemoval: lastOrFirst ? 4 : 8,
          paddingVerticalRemoval: 16,
        }}
        withText={false}
        withToolTip
        {...singleTaskProps}
      />
    );
  });

  const isMoreTasks = withLimit && tooltipTasksSize > 0;
  const renderMoreTasks = isMoreTasks && (
    <TaskDropdownList
      containerHeight={tableContainerHeight}
      containerWidth={tooltipSettings.containerWidth}
      headerTitle={headerTitle}
      isTaskInactiveByFilter={isTaskInactiveByFilter}
      paddingVerticalRemoval={4}
      tasks={toolTipTasks}
      triggerText={`${_.size(toolTipTasks)}+`}
    />
  );

  return (
    <div className={classnames(CLASS_NAME, { 'default-cell': defaultCell })}>
      {renderTasks}
      {renderMoreTasks}
    </div>
  );
};

TasksCell.propTypes = {
  issues: PropTypes.arrayOf(PropTypes.shape({})), // eslint-disable-line react/no-unused-prop-types
  recent_tasks: PropTypes.arrayOf(PropTypes.shape({})), // eslint-disable-line react/no-unused-prop-types
  tasks: PropTypes.arrayOf(PropTypes.shape({})), // eslint-disable-line react/no-unused-prop-types
};

export default TasksCell;
